// todo: import from swagger ?

export enum RightsHolderType {
  Author = "A",
  Publisher = "I",
  SisterOrganization = "M",
  CooperationPartner = "S",
}
